import { combineReducers } from 'redux';
import orgsReducer from './orgs';
import appsReducer from './apps';
import releasesReducer from './releases';
import appGroupsReducer from './appGroups';
import statisticsReducer from './statistics';
import buildDistributionReducer from './buildDistribution';
import releaseStepsReducer from '@/reducers/releaseStep';
import { stepRunsReducer } from '@/reducers/stepRun';
import { stepConfigsReducer } from '@/reducers/stepConfig';
import { timelineEventsReducer } from './timelineEvents';
import { orgChecklistItemTemplates } from './orgChecklistItemTemplates';

const entities = combineReducers({
    orgs: orgsReducer,
    apps: appsReducer, // TODO: coming soon... workflowReducer
    releases: releasesReducer,
    releaseSteps: releaseStepsReducer,
    stepRuns: stepRunsReducer,
    stepConfigs: stepConfigsReducer,
    timelineEvents: timelineEventsReducer,
    appGroups: appGroupsReducer,
    statistics: statisticsReducer,
    buildDistribution: buildDistributionReducer,
    orgChecklistItemTemplates,
});

export default entities;
